import api from '../../common/libs/api.js';

const homeCourse = {
  state: {
    oneInfo: {
      info: {
        title: '',
        params: [{}]
      }
    },   //保存面授一对一预约表单的信息
    eightInfo: {
      info: {
        params: [{}]
      }
    },   //保存面授8人班预约表单的信息
    seoInfo: { //面授1对1seo的信息，提前渲染
      headImg: '',
      middleFirstImg: '',
      middleSecondImg: '',
      middleThirdImg: '',
      middleFourImg: '',
      personFirstImg: '',
      personSecondImg: '',
      personThirdImg: ''
    },
    eightSeoInfo: {//8人班seo信息
      headImg: '',
      middleFirstImg: '',
      middleSecondImg: '',
      middleThirdImg: '',
      middleFourImg: ''
    },
    onlineSeoInfo: {//在线seo信息
      headImg: '',
      middleFirstImg: '',
      middleSecondImg: '',
      middleThirdImg: '',
      personFirstImg: '',
      personSecondImg: '',
      personThirdImg: ''
    }
  },
  mutations: {
    setOnlineSeoInfo(homeCourse, seoInfo) {
      homeCourse.onlineSeoInfo = seoInfo;
    },
    setEightSeoInfo(homeCourse, seoInfo) {
      homeCourse.eightSeoInfo = seoInfo
    },
    setSeoInfo(homeCourse, seoInfo) {
      homeCourse.seoInfo = seoInfo;
    },
    addOneInfo(homeCourse, oneInfo) {
      homeCourse.oneInfo = oneInfo;
    },
    addEightInfo(homeCourse, eightInfo) {
      homeCourse.eightInfo = eightInfo;
    }
  },
  actions: {
    getOneInfo(context, payload) {
      return api.apiMethod.dataSet.post(payload).then(res => {
        if (res.data.errid == 0) {
          context.commit('addOneInfo', res.data.content);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      });
    },
    getEightInfo(context, payload) {
      return api.apiMethod.dataSet.post(payload).then(res => {
        if (res.data.errid == 0) {
          context.commit('addEightInfo', res.data.content);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      });
    }
  }
};

export default homeCourse;


// WEBPACK FOOTER //
// ./src/stores/modules/homeCourse.js